// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"ca19236f","702":"b2bca3a5"}[chunkId] + ".chunk.css";
};